(() => {
  const STORAGE_KEY = 'da_wishlist';
  const STORAGE_CAP = 24;
  const readList = () => {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      return Array.isArray(list) ? list.filter((item) => item && item.handle) : [];
    } catch (error) {
      return [];
    }
  };
  const writeList = (list) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, STORAGE_CAP)));
    } catch (error) {
      // localStorage nedostupan — preskoci
    }
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  };
  /*
    Tihi upis osvezene stavke: NE salje wishlist:change, jer bi taj dogadjaj
    pokrenuo novi render, koji bi opet pokrenuo popravku — beskonacna petlja.
    Popravljena kartica se azurira direktno u DOM-u.
  */
  const writeStoredItem = (fresh) => {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      if (!Array.isArray(list)) return;
      const next = list.map((entry) => (entry && entry.handle === fresh.handle ? fresh : entry));
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
      // localStorage nedostupan — popravka ostaje samo za ovu posetu
    }
  };

  /*
    Dodavanje u korpu direktno sa liste.

    U korpu ide varijanta, a ne proizvod, pa se dugme pojavljuje samo kad
    proizvod ima tacno jednu varijantu i kad je ona zapamcena. Za proizvode
    sa vise varijanti (npr. dve gramaze) vodi na stranicu proizvoda, da
    kupcu ne bi tiho ubacili pogresnu. Stavke sacuvane pre ove izmene nemaju
    zapamcenu varijantu, pa i one vode na stranicu proizvoda.
  */
  const addToCart = async (item, button) => {
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: item.variant, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
        }),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message);

      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.href = '/cart';
        return;
      }
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 1500);
    } catch (error) {
      // ako dodavanje ne uspe, kupac bar stigne do stranice proizvoda
      window.location.href = item.url;
      return;
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  };

  /*
    Samopopravka zapisa. Sacuvana stavka drzi sliku, cenu i URL iz trenutka
    cuvanja. Kad vlasnik zameni sliku proizvoda u adminu, stari CDN fajl
    nestane i kupcu zauvek ostane ikona slomljene slike; isto tako, cena i
    URL zapamceni na srpskoj prodavnici ostaju srpski i kad kupac gleda
    /sl-si. Kad slika pukne ili se valuta ne poklapa, jednom se povuce
    /products/<handle>.js (kroz Shopify.routes.root, pa putanja prati jezik)
    i osvezeni podaci se upisu nazad u localStorage.

    Cena se ne formatira preko Intl, jer Intl za sl-SI daje "7,95 €", a tema
    prikazuje "€7,95". Format se izvlaci iz uzorka koji je Liquid renderovao
    (data-money-sample = {{ 123456 | money }}), pa osvezena cena izgleda
    identicno kao svaka druga na stranici.
  */
  const buildMoneyFormatter = (sample) => {
    const text = String(sample || '');
    const match = text.match(/\d[\d., \s]*\d|\d/);
    if (!match) return null;
    const number = match[0];
    const prefix = text.slice(0, match.index);
    const suffix = text.slice(match.index + number.length);
    const separators = number.replace(/\d/g, '');
    const decimals = number.replace(/\D/g, '').length >= 6 ? 2 : 0;
    const decimalSeparator = decimals ? separators.slice(-1) : '';
    const thousandsSeparator = separators.length > (decimals ? 1 : 0) ? separators.charAt(0) : '';
    return (cents) => {
      const amount = decimals ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
      const parts = amount.split('.');
      const whole = thousandsSeparator
        ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)
        : parts[0];
      return prefix + whole + (decimals ? decimalSeparator + parts[1] : '') + suffix;
    };
  };

  const moneyToken = (sample) => String(sample || '').replace(/[\d., \s]/g, '');

  const withImageWidth = (url) => {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=400';
  };

  const fetchProduct = async (handle) => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js');
    if (!response.ok) return null;
    return response.json();
  };

  /*
    Prevodi: Liquid (snippets/wishlist-row.liquid) upisuje data-i18n-*
    atribute na <wishlist-row>; fallback je postojeci srpski literal,
    pa nista ne puca ni kad atributi fale.
  */
  const t = (root, key, fallback) => {
    const source =
      (root && root.closest && root.closest('[data-i18n-choose]')) || document.querySelector('[data-i18n-choose]');
    return (source && source.dataset && source.dataset[key]) || fallback;
  };

  const buildCartAction = (item, root) => {
    const jednaVarijanta = item.variant && item.variants === 1;

    if (!jednaVarijanta) {
      const choose = document.createElement('a');
      choose.className = 'wishlist-row__cart wishlist-row__cart--choose';
      choose.href = item.url;
      choose.textContent = t(root, 'i18nChoose', 'Izaberi');
      choose.setAttribute(
        'aria-label',
        t(root, 'i18nChooseOption', 'Izaberi opciju: {{ title }}').replace('{{ title }}', item.title || '')
      );
      return choose;
    }

    const add = document.createElement('button');
    add.type = 'button';
    add.className = 'wishlist-row__cart';
    add.textContent = t(root, 'i18nAdd', 'Dodaj');
    add.setAttribute(
      'aria-label',
      t(root, 'i18nAddToCart', 'Dodaj u korpu: {{ title }}').replace('{{ title }}', item.title || '')
    );
    add.addEventListener('click', () => addToCart(item, add));
    return add;
  };

  if (!customElements.get('wishlist-button')) {
    customElements.define(
      'wishlist-button',
      class WishlistButton extends HTMLElement {
        connectedCallback() {
          try {
            this.product = JSON.parse(this.querySelector('[data-wishlist-product]').textContent);
          } catch (error) {
            return;
          }
          this.button = this.querySelector('.wishlist-button__btn');
          this.label = this.querySelector('.wishlist-button__label');
          this.button.addEventListener('click', () => this.toggle());
          this.onChange = () => this.syncState();
          document.addEventListener('wishlist:change', this.onChange);
          this.syncState();
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:change', this.onChange);
        }

        isSaved() {
          return readList().some((item) => item.handle === this.product.handle);
        }

        toggle() {
          const list = readList();
          if (this.isSaved()) {
            writeList(list.filter((item) => item.handle !== this.product.handle));
          } else {
            writeList([this.product, ...list]);
          }
        }

        syncState() {
          const saved = this.isSaved();
          this.classList.toggle('is-saved', saved);
          this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
          this.label.textContent = saved ? this.label.dataset.labelSaved : this.label.dataset.labelSave;
        }
      }
    );
  }

  if (!customElements.get('wishlist-row')) {
    customElements.define(
      'wishlist-row',
      class WishlistRow extends HTMLElement {
        connectedCallback() {
          this.container = this.querySelector('[data-wishlist-items]');
          this.emptyNote = this.querySelector('[data-wishlist-empty]');
          this.showEmpty = this.hasAttribute('data-show-empty');
          this.formatMoney = buildMoneyFormatter(this.dataset.moneySample);
          this.currencyToken = moneyToken(this.dataset.moneySample);
          this.repaired = 0;
          this.onChange = () => this.render();
          document.addEventListener('wishlist:change', this.onChange);
          this.render();
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:change', this.onChange);
        }

        render() {
          const current = this.dataset.currentHandle;
          const items = readList().filter((item) => item.handle !== current);
          this.container.textContent = '';
          if (!items.length) {
            // na profilu ostaje vidljiv sa praznom porukom, na proizvodu se krije
            if (this.showEmpty) {
              this.removeAttribute('hidden');
              if (this.emptyNote) this.emptyNote.removeAttribute('hidden');
            } else {
              this.setAttribute('hidden', '');
            }
            return;
          }
          if (this.emptyNote) this.emptyNote.setAttribute('hidden', '');
          items.forEach((item) => {
            const card = document.createElement('div');
            card.className = 'wishlist-row__card';
            const link = document.createElement('a');
            link.className = 'wishlist-row__link';
            link.href = item.url;
            const img = document.createElement('img');
            img.className = 'wishlist-row__img';
            img.src = item.img || '';
            img.alt = item.title || '';
            img.loading = 'lazy';
            img.width = 140;
            img.height = 140;
            const title = document.createElement('span');
            title.className = 'wishlist-row__name';
            title.textContent = item.title || '';
            const price = document.createElement('span');
            price.className = 'wishlist-row__price';
            price.textContent = item.price || '';
            link.append(img, title, price);
            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'wishlist-row__remove';
            remove.setAttribute(
              'aria-label',
              t(this, 'i18nRemove', 'Ukloni sa liste: {{ title }}').replace('{{ title }}', item.title || '')
            );
            remove.textContent = '×';
            remove.addEventListener('click', () => {
              writeList(readList().filter((entry) => entry.handle !== item.handle));
            });

            card.append(link, remove, buildCartAction(item, this));
            this.container.append(card);

            const nodes = { link, img, price, title };
            img.addEventListener('error', () => this.refresh(item, nodes));
            if (!item.img) this.refresh(item, nodes);
            if (this.staleCurrency(item)) this.refresh(item, nodes);
          });
          this.removeAttribute('hidden');
        }

        // Cena je iz druge valute ako u njoj nema znaka valute tekuceg trzista.
        staleCurrency(item) {
          if (!this.formatMoney || !this.currencyToken || !item.price) return false;
          if (item.currency && this.dataset.currency) return item.currency !== this.dataset.currency;
          return item.price.indexOf(this.currencyToken) === -1;
        }

        async refresh(item, nodes) {
          if (item.refreshing || this.repaired >= 8) return;
          item.refreshing = true;
          this.repaired += 1;
          let product = null;
          try {
            product = await fetchProduct(item.handle);
          } catch (error) {
            product = null;
          }
          if (!product) {
            // proizvod vise ne postoji — sacuvana stavka se NE brise (to je
            // kupceva lista), samo se slika zameni praznim mestom
            this.showMissing(nodes);
            return;
          }
          const fresh = {
            ...item,
            title: product.title || item.title,
            url: product.url || item.url,
            img: withImageWidth(product.featured_image),
            price_cents: product.price,
            currency: this.dataset.currency || item.currency,
          };
          delete fresh.refreshing;
          if (this.formatMoney && typeof product.price === 'number') {
            fresh.price = this.formatMoney(product.price);
          }
          if (fresh.img) {
            nodes.img.src = fresh.img;
          } else {
            this.showMissing(nodes);
          }
          nodes.link.href = fresh.url;
          nodes.price.textContent = fresh.price || '';
          nodes.title.textContent = fresh.title || '';
          writeStoredItem(fresh);
        }

        showMissing(nodes) {
          const placeholder = document.createElement('span');
          placeholder.className = 'wishlist-row__img wishlist-row__img--missing';
          placeholder.setAttribute('aria-hidden', 'true');
          nodes.img.replaceWith(placeholder);
        }
      }
    );
  }
})();
